// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditProfessions {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 10px 0 60px;
    animation: fadeInProf 0.3s ease-in-out;
    font-family: "Inter", sans-serif;
}

@keyframes fadeInProf {
    from {
        opacity: 0;
        transform: translateY(6px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.editProfessionsContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.editProfessionsCard {
    width: 90%;
    max-width: 900px;
    background-color: #0E1B1B;
    border: 1px solid #1E2D2D;
    border-radius: 14px;
    padding: 24px 28px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    box-sizing: border-box;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

/* Header */
.editProfessionsHeader {
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-bottom: 1px solid #1E2D2D;
    padding-bottom: 16px;
}

.editProfessionsTitleRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
}

.editProfessionsTitle {
    font-size: 20px;
    font-weight: 700;
    color: #FFFFFF;
    letter-spacing: -0.01em;
    display: flex;
    align-items: center;
    gap: 10px;
}

.editProfessionsTitleIcon {
    color: #4DCBCA;
    display: flex;
    align-items: center;
}

.selectedCountBadge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 14px;
    background: rgba(77, 203, 202, 0.15);
    color: #4DCBCA;
    border: 1px solid rgba(77, 203, 202, 0.35);
    border-radius: 9999px;
    font-size: 13px;
    font-weight: 600;
}

.editProfessionsSubtitle {
    font-size: 13.5px;
    color: #839696;
    line-height: 1.5;
    margin: 0;
}

/* Selected Tray */
.selectedProfessionsTray {
    background: #142424;
    border: 1px dashed #233737;
    border-radius: 12px;
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.selectedTrayHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    font-weight: 600;
    color: #839696;
}

.clearAllBtn {
    background: none;
    border: none;
    color: #f87171;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    padding: 2px 8px;
    border-radius: 6px;
    transition: all 0.2s;
}

.clearAllBtn:hover {
    background: rgba(239, 68, 68, 0.15);
    color: #ef4444;
}

.selectedChipsList {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    max-height: 140px;
    overflow-y: auto;
    padding-right: 4px;
}

.selectedChip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(77, 203, 202, 0.12);
    border: 1px solid #4DCBCA;
    color: #4DCBCA;
    font-size: 13px;
    font-weight: 600;
    padding: 5px 12px;
    border-radius: 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    animation: popIn 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes popIn {
    from {
        transform: scale(0.85);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
}

.selectedChipRemove {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #839696;
    border-radius: 50%;
    padding: 2px;
    transition: all 0.2s;
}

.selectedChipRemove:hover {
    color: #ef4444;
    background: rgba(239, 68, 68, 0.2);
}

/* Search Bar */
.professionsSearchBox {
    position: relative;
    display: flex;
    align-items: center;
    background: #142424;
    border: 1px solid #233737;
    border-radius: 12px;
    padding: 10px 16px;
    transition: all 0.2s ease;
}

.professionsSearchBox:focus-within {
    border-color: #4DCBCA;
    background: #162a2a;
    box-shadow: 0 0 0 3px rgba(77, 203, 202, 0.15);
}

.professionsSearchIcon {
    color: #839696;
    margin-right: 10px;
    font-size: 20px;
}

.professionsSearchInput {
    flex: 1 1;
    border: none;
    background: transparent;
    outline: none;
    font-size: 14.5px;
    color: #FFFFFF;
    font-family: inherit;
}

.professionsSearchInput::placeholder {
    color: #839696;
}

.professionsClearSearch {
    cursor: pointer;
    color: #839696;
    padding: 2px;
    display: flex;
    align-items: center;
    border-radius: 50%;
    transition: color 0.2s;
}

.professionsClearSearch:hover {
    color: #FFFFFF;
}

/* Category Filter Tabs */
.categoryTabsContainer {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 6px;
    scrollbar-width: thin;
    scrollbar-color: #233737 transparent;
}

.categoryTabsContainer::-webkit-scrollbar {
    height: 4px;
}

.categoryTabsContainer::-webkit-scrollbar-thumb {
    background: #233737;
    border-radius: 4px;
}

.categoryTab {
    white-space: nowrap;
    background: #142424;
    border: 1px solid #233737;
    color: #839696;
    font-size: 13px;
    font-weight: 600;
    padding: 7px 16px;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.categoryTab:hover {
    border-color: #4DCBCA;
    color: #4DCBCA;
    background: rgba(77, 203, 202, 0.08);
}

.categoryTab.active {
    background: #4DCBCA;
    color: #0E1B1B;
    font-weight: 700;
    border-color: #4DCBCA;
    box-shadow: 0 2px 8px rgba(77, 203, 202, 0.25);
}

/* Catalog List */
.professionsCatalog {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-height: 440px;
    overflow-y: auto;
    padding-right: 6px;
    scrollbar-width: thin;
    scrollbar-color: #233737 transparent;
}

.professionsCatalog::-webkit-scrollbar {
    width: 5px;
}

.professionsCatalog::-webkit-scrollbar-thumb {
    background: #233737;
    border-radius: 4px;
}

.professionCategoryGroup {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.professionCategoryHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 0;
    border-bottom: 1px solid #1E2D2D;
}

.professionCategoryName {
    font-size: 13.5px;
    font-weight: 700;
    color: #4DCBCA;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.professionCategoryCount {
    font-size: 12px;
    color: #839696;
    font-weight: 500;
}

.professionTitlesGrid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 10px;
}

.professionItemCard {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 11px 14px;
    background: #142424;
    border: 1px solid #233737;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    -webkit-user-select: none;
            user-select: none;
}

.professionItemCard:hover {
    border-color: #4DCBCA;
    background: #182e2e;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.professionItemCard.selected {
    background: rgba(77, 203, 202, 0.12);
    border-color: #4DCBCA;
    box-shadow: 0 2px 8px rgba(77, 203, 202, 0.2);
}

.professionItemLeft {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1 1;
    min-width: 0;
}

.professionCheckbox {
    width: 18px;
    height: 18px;
    border-radius: 5px;
    border: 1.5px solid #2d4545;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0E1B1B;
    color: #0E1B1B;
    font-size: 12px;
    transition: all 0.2s;
    flex-shrink: 0;
}

.professionItemCard.selected .professionCheckbox {
    background: #4DCBCA;
    border-color: #4DCBCA;
    color: #0E1B1B;
}

.professionItemTitle {
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.professionItemCard.selected .professionItemTitle {
    color: #4DCBCA;
    font-weight: 600;
}

.professionPopularBadge {
    font-size: 11px;
    color: #839696;
    background: #193131;
    padding: 2px 6px;
    border-radius: 6px;
    font-weight: 600;
    flex-shrink: 0;
}

.professionItemCard.selected .professionPopularBadge {
    background: rgba(77, 203, 202, 0.25);
    color: #4DCBCA;
}

/* Action Footer */
.editProfessionsFooter {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 14px;
    padding-top: 16px;
    border-top: 1px solid #1E2D2D;
}

.saveProfessionsBtn {
    background: #4DCBCA;
    color: #0E1B1B;
    border: none;
    border-radius: 12px;
    height: 44px;
    padding: 0 28px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 4px 14px rgba(77, 203, 202, 0.3);
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    box-sizing: border-box;
}

.saveProfessionsBtn:hover:not(:disabled) {
    background: #5eead4;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(77, 203, 202, 0.45);
}

.saveProfessionsBtn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    box-shadow: none;
}

.cancelProfessionsBtn {
    background: transparent;
    border: 1px solid #233737;
    color: #839696;
    border-radius: 12px;
    height: 44px;
    padding: 0 24px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.cancelProfessionsBtn:hover {
    background: #142424;
    color: #FFFFFF;
    border-color: #354e4e;
}

/* Community Transition Notice Banner */
.professionsCommunityNotice {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
    border-radius: 10px;
    font-size: 13px;
    line-height: 1.45;
    font-family: "Inter", sans-serif;
    box-sizing: border-box;
    width: 100%;
    animation: fadeInNoticeProf 0.25s ease;
}

@keyframes fadeInNoticeProf {
    from {
        opacity: 0;
        transform: translateY(-4px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.professionsCommunityNotice.notice-warning {
    background-color: rgba(245, 158, 11, 0.1);
    border: 1px solid rgba(245, 158, 11, 0.35);
    color: #fde68a;
}

.professionsCommunityNotice.notice-info {
    background-color: rgba(77, 203, 202, 0.08);
    border: 1px solid rgba(77, 203, 202, 0.25);
    color: #99f6e4;
}

.professionsCommunityNotice.notice-neutral {
    background-color: #142424;
    border: 1px dashed #233737;
    color: #839696;
}

.professionsCommunityNotice .noticeIcon {
    font-size: 16px;
    line-height: 1;
    margin-top: 2px;
    flex-shrink: 0;
}

.professionsCommunityNotice .noticeText {
    flex: 1 1;
}

.professionsCommunityNotice strong {
    color: #ffffff;
    font-weight: 600;
}

/* Empty search state */
.noProfessionsFound {
    text-align: center;
    padding: 36px 16px;
    color: #839696;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

@media (max-width: 640px) {
    .editProfessionsCard {
        width: 95%;
        padding: 18px 14px;
    }
    .professionTitlesGrid {
        grid-template-columns: 1fr;
    }
    .editProfessionsFooter {
        flex-direction: column-reverse;
    }
    .saveProfessionsBtn,
    .cancelProfessionsBtn {
        width: 100%;
        justify-content: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/EditProfessions/EditProfessions.css"],"names":[],"mappings":"AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA,WAAW;AACX;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,oCAAoC;IACpC,cAAc;IACd,0CAA0C;IAC1C,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,oCAAoC;IACpC,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,wCAAwC;IACxC,6DAA6D;AACjE;;AAEA;IACI;QACI,sBAAsB;QACtB,UAAU;IACd;IACA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,kCAAkC;AACtC;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,8CAA8C;IAC9C,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,sBAAsB;IACtB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,yCAAyC;IACzC,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;QACI,UAAU;QACV,kBAAkB;IACtB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,8BAA8B;IAClC;IACA;;QAEI,WAAW;QACX,uBAAuB;IAC3B;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\");\n\n.EditProfessions {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding: 10px 0 60px;\n    animation: fadeInProf 0.3s ease-in-out;\n    font-family: \"Inter\", sans-serif;\n}\n\n@keyframes fadeInProf {\n    from {\n        opacity: 0;\n        transform: translateY(6px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.editProfessionsContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n}\n\n.editProfessionsCard {\n    width: 90%;\n    max-width: 900px;\n    background-color: #0E1B1B;\n    border: 1px solid #1E2D2D;\n    border-radius: 14px;\n    padding: 24px 28px;\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    box-sizing: border-box;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\n}\n\n/* Header */\n.editProfessionsHeader {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    border-bottom: 1px solid #1E2D2D;\n    padding-bottom: 16px;\n}\n\n.editProfessionsTitleRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 12px;\n}\n\n.editProfessionsTitle {\n    font-size: 20px;\n    font-weight: 700;\n    color: #FFFFFF;\n    letter-spacing: -0.01em;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.editProfessionsTitleIcon {\n    color: #4DCBCA;\n    display: flex;\n    align-items: center;\n}\n\n.selectedCountBadge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 14px;\n    background: rgba(77, 203, 202, 0.15);\n    color: #4DCBCA;\n    border: 1px solid rgba(77, 203, 202, 0.35);\n    border-radius: 9999px;\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.editProfessionsSubtitle {\n    font-size: 13.5px;\n    color: #839696;\n    line-height: 1.5;\n    margin: 0;\n}\n\n/* Selected Tray */\n.selectedProfessionsTray {\n    background: #142424;\n    border: 1px dashed #233737;\n    border-radius: 12px;\n    padding: 14px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.selectedTrayHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 13px;\n    font-weight: 600;\n    color: #839696;\n}\n\n.clearAllBtn {\n    background: none;\n    border: none;\n    color: #f87171;\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    padding: 2px 8px;\n    border-radius: 6px;\n    transition: all 0.2s;\n}\n\n.clearAllBtn:hover {\n    background: rgba(239, 68, 68, 0.15);\n    color: #ef4444;\n}\n\n.selectedChipsList {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    max-height: 140px;\n    overflow-y: auto;\n    padding-right: 4px;\n}\n\n.selectedChip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    background: rgba(77, 203, 202, 0.12);\n    border: 1px solid #4DCBCA;\n    color: #4DCBCA;\n    font-size: 13px;\n    font-weight: 600;\n    padding: 5px 12px;\n    border-radius: 20px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n    animation: popIn 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n@keyframes popIn {\n    from {\n        transform: scale(0.85);\n        opacity: 0;\n    }\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n.selectedChipRemove {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #839696;\n    border-radius: 50%;\n    padding: 2px;\n    transition: all 0.2s;\n}\n\n.selectedChipRemove:hover {\n    color: #ef4444;\n    background: rgba(239, 68, 68, 0.2);\n}\n\n/* Search Bar */\n.professionsSearchBox {\n    position: relative;\n    display: flex;\n    align-items: center;\n    background: #142424;\n    border: 1px solid #233737;\n    border-radius: 12px;\n    padding: 10px 16px;\n    transition: all 0.2s ease;\n}\n\n.professionsSearchBox:focus-within {\n    border-color: #4DCBCA;\n    background: #162a2a;\n    box-shadow: 0 0 0 3px rgba(77, 203, 202, 0.15);\n}\n\n.professionsSearchIcon {\n    color: #839696;\n    margin-right: 10px;\n    font-size: 20px;\n}\n\n.professionsSearchInput {\n    flex: 1;\n    border: none;\n    background: transparent;\n    outline: none;\n    font-size: 14.5px;\n    color: #FFFFFF;\n    font-family: inherit;\n}\n\n.professionsSearchInput::placeholder {\n    color: #839696;\n}\n\n.professionsClearSearch {\n    cursor: pointer;\n    color: #839696;\n    padding: 2px;\n    display: flex;\n    align-items: center;\n    border-radius: 50%;\n    transition: color 0.2s;\n}\n\n.professionsClearSearch:hover {\n    color: #FFFFFF;\n}\n\n/* Category Filter Tabs */\n.categoryTabsContainer {\n    display: flex;\n    gap: 8px;\n    overflow-x: auto;\n    padding-bottom: 6px;\n    scrollbar-width: thin;\n    scrollbar-color: #233737 transparent;\n}\n\n.categoryTabsContainer::-webkit-scrollbar {\n    height: 4px;\n}\n\n.categoryTabsContainer::-webkit-scrollbar-thumb {\n    background: #233737;\n    border-radius: 4px;\n}\n\n.categoryTab {\n    white-space: nowrap;\n    background: #142424;\n    border: 1px solid #233737;\n    color: #839696;\n    font-size: 13px;\n    font-weight: 600;\n    padding: 7px 16px;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.categoryTab:hover {\n    border-color: #4DCBCA;\n    color: #4DCBCA;\n    background: rgba(77, 203, 202, 0.08);\n}\n\n.categoryTab.active {\n    background: #4DCBCA;\n    color: #0E1B1B;\n    font-weight: 700;\n    border-color: #4DCBCA;\n    box-shadow: 0 2px 8px rgba(77, 203, 202, 0.25);\n}\n\n/* Catalog List */\n.professionsCatalog {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    max-height: 440px;\n    overflow-y: auto;\n    padding-right: 6px;\n    scrollbar-width: thin;\n    scrollbar-color: #233737 transparent;\n}\n\n.professionsCatalog::-webkit-scrollbar {\n    width: 5px;\n}\n\n.professionsCatalog::-webkit-scrollbar-thumb {\n    background: #233737;\n    border-radius: 4px;\n}\n\n.professionCategoryGroup {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.professionCategoryHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 6px 0;\n    border-bottom: 1px solid #1E2D2D;\n}\n\n.professionCategoryName {\n    font-size: 13.5px;\n    font-weight: 700;\n    color: #4DCBCA;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n.professionCategoryCount {\n    font-size: 12px;\n    color: #839696;\n    font-weight: 500;\n}\n\n.professionTitlesGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n    gap: 10px;\n}\n\n.professionItemCard {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 11px 14px;\n    background: #142424;\n    border: 1px solid #233737;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    user-select: none;\n}\n\n.professionItemCard:hover {\n    border-color: #4DCBCA;\n    background: #182e2e;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.professionItemCard.selected {\n    background: rgba(77, 203, 202, 0.12);\n    border-color: #4DCBCA;\n    box-shadow: 0 2px 8px rgba(77, 203, 202, 0.2);\n}\n\n.professionItemLeft {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex: 1;\n    min-width: 0;\n}\n\n.professionCheckbox {\n    width: 18px;\n    height: 18px;\n    border-radius: 5px;\n    border: 1.5px solid #2d4545;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #0E1B1B;\n    color: #0E1B1B;\n    font-size: 12px;\n    transition: all 0.2s;\n    flex-shrink: 0;\n}\n\n.professionItemCard.selected .professionCheckbox {\n    background: #4DCBCA;\n    border-color: #4DCBCA;\n    color: #0E1B1B;\n}\n\n.professionItemTitle {\n    font-size: 14px;\n    font-weight: 500;\n    color: #FFFFFF;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.professionItemCard.selected .professionItemTitle {\n    color: #4DCBCA;\n    font-weight: 600;\n}\n\n.professionPopularBadge {\n    font-size: 11px;\n    color: #839696;\n    background: #193131;\n    padding: 2px 6px;\n    border-radius: 6px;\n    font-weight: 600;\n    flex-shrink: 0;\n}\n\n.professionItemCard.selected .professionPopularBadge {\n    background: rgba(77, 203, 202, 0.25);\n    color: #4DCBCA;\n}\n\n/* Action Footer */\n.editProfessionsFooter {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 14px;\n    padding-top: 16px;\n    border-top: 1px solid #1E2D2D;\n}\n\n.saveProfessionsBtn {\n    background: #4DCBCA;\n    color: #0E1B1B;\n    border: none;\n    border-radius: 12px;\n    height: 44px;\n    padding: 0 28px;\n    font-size: 15px;\n    font-weight: 700;\n    cursor: pointer;\n    box-shadow: 0 4px 14px rgba(77, 203, 202, 0.3);\n    transition: all 0.2s ease;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    box-sizing: border-box;\n}\n\n.saveProfessionsBtn:hover:not(:disabled) {\n    background: #5eead4;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(77, 203, 202, 0.45);\n}\n\n.saveProfessionsBtn:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n.cancelProfessionsBtn {\n    background: transparent;\n    border: 1px solid #233737;\n    color: #839696;\n    border-radius: 12px;\n    height: 44px;\n    padding: 0 24px;\n    font-size: 15px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n}\n\n.cancelProfessionsBtn:hover {\n    background: #142424;\n    color: #FFFFFF;\n    border-color: #354e4e;\n}\n\n/* Community Transition Notice Banner */\n.professionsCommunityNotice {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 12px 16px;\n    border-radius: 10px;\n    font-size: 13px;\n    line-height: 1.45;\n    font-family: \"Inter\", sans-serif;\n    box-sizing: border-box;\n    width: 100%;\n    animation: fadeInNoticeProf 0.25s ease;\n}\n\n@keyframes fadeInNoticeProf {\n    from {\n        opacity: 0;\n        transform: translateY(-4px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.professionsCommunityNotice.notice-warning {\n    background-color: rgba(245, 158, 11, 0.1);\n    border: 1px solid rgba(245, 158, 11, 0.35);\n    color: #fde68a;\n}\n\n.professionsCommunityNotice.notice-info {\n    background-color: rgba(77, 203, 202, 0.08);\n    border: 1px solid rgba(77, 203, 202, 0.25);\n    color: #99f6e4;\n}\n\n.professionsCommunityNotice.notice-neutral {\n    background-color: #142424;\n    border: 1px dashed #233737;\n    color: #839696;\n}\n\n.professionsCommunityNotice .noticeIcon {\n    font-size: 16px;\n    line-height: 1;\n    margin-top: 2px;\n    flex-shrink: 0;\n}\n\n.professionsCommunityNotice .noticeText {\n    flex: 1;\n}\n\n.professionsCommunityNotice strong {\n    color: #ffffff;\n    font-weight: 600;\n}\n\n/* Empty search state */\n.noProfessionsFound {\n    text-align: center;\n    padding: 36px 16px;\n    color: #839696;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n}\n\n@media (max-width: 640px) {\n    .editProfessionsCard {\n        width: 95%;\n        padding: 18px 14px;\n    }\n    .professionTitlesGrid {\n        grid-template-columns: 1fr;\n    }\n    .editProfessionsFooter {\n        flex-direction: column-reverse;\n    }\n    .saveProfessionsBtn,\n    .cancelProfessionsBtn {\n        width: 100%;\n        justify-content: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
